import { ReferralProgram } from "../components/ReferralProgram"
import { entries } from "../data/entries"
import { Box, Container, Grid } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import React, { useEffect, useState } from "react"
import { SEO } from "../components/SEO"
import { PATHS } from "../constants/paths"
import { getTurretBoxes } from "../api/boxes"
import { useAppSelector } from "../store"
import { RarityItem } from "../components/boxes/RarityItem"
import { NftCard } from "../components/boxes/NftCard"
import { BoxList } from "../components/boxes/BoxList"

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 18,
    "@media (max-width: 600px)": {
      fontSize: 16,
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 20,
    "@media (max-width: 600px)": {
      fontSize: 16,
    },
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}))

const NftBoxesTurrets2 = () => {
  const { user } = useAppSelector((state) => state.user)

  const [boxes, setBoxes] = useState([])

  const loadBoxes = async () => {
    const data = (await getTurretBoxes()) || []
    setBoxes(data)
  }

  useEffect(() => {
    let mounted = true

    ;(async () => {
      if (!mounted) return
      await loadBoxes()
    })()

    const intervalId = setInterval(() => {
      if (mounted) {
        loadBoxes()
      }
    }, 2000)

    return () => {
      mounted = false
      clearInterval(intervalId)
    }
  }, [])

  return (
    <Box>
      <SEO
        title="Zombie TD | Buy NFT Turret Boxes - Unlock Your Army"
        description="NFT Turrets Overview"
        ogTitle="Zombie TD | NFT Turret Boxes"
        ogDescription="Purchase NFT Turret Boxes and strengthen your army with powerful turrets."
        ogUrl={PATHS.NFT_BOXES.NFT_BOXES_WITH_TURRETS.PATH}
      />
      <Box className="content content-nft-boxes content-nft-boxes-commanders">
        <Box className="content-head" mb={5} textAlign="center">
          <Container fixed>
            <Typography variant="h1">NFT Boxes with Turrets 2</Typography>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Sales Starts In: TBA
            </Typography>
            {/*<Box sx={{display: 'flex', justifyContent: 'center', mt: 2}}>*/}
            {/*  <TimeLeft y={2022} m={10} d={10}/>*/}
            {/*</Box>*/}
          </Container>
        </Box>
        <Box className="content-body">
          <Container fixed>
            <Box>
              <BoxList boxes={boxes} user={user} />
            </Box>

            <Box sx={{ mt: { xs: 4, sm: 6, md: 8 } }}>
              <Typography variant="h2" textAlign={"center"} gutterBottom>
                NFT Turrets Overview
              </Typography>

              <Typography variant="subtitle1" textAlign="left" sx={{ mb: 2 }}>
                NFT Turrets are core in-game assets used in battles,
                progression, and competitive modes. Only Turrets owned by you
                can be equipped and used during gameplay.
              </Typography>

              <Typography variant="subtitle1" mb={2} textAlign="left">
                Each Turret has unique combat mechanics, type, and rarity.
                Owning a diverse set of Turrets increases your strategic
                flexibility and improves your chances of success in campaigns,
                events, PvP battles, and tournaments. Stronger and rarer Turrets
                provide higher combat efficiency and open additional
                opportunities to earn in-game rewards. The game features 5 types
                of NFT Turrets, each with unique combat characteristics:
              </Typography>

              <Grid container spacing={2} sx={{ mb: 4 }}>
                {entries.turrets2.map((turret) => {
                  return (
                    <Grid item xs={6} md={3} lg>
                      <Typography
                        variant="h4"
                        textAlign={"center"}
                        noWrap
                        sx={{
                          my: 2,
                          fontSize: {
                            xs: 12,
                            md: 14,
                          },
                        }}
                      >
                        {turret.title}
                      </Typography>
                      <NftCard image={turret.image} video={turret.video} />
                      <Box textAlign="center">
                        <Typography
                          variant="body1"
                          mt={1}
                          sx={{ color: "#EEE" }}
                        >
                          {turret.brief}
                        </Typography>
                      </Box>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
            <Box
              textAlign="center"
              sx={{
                mt: { xss: 2, xs: 5, sm: 6, md: 8, lg: 10 },
                mb: { lg: 5 },
              }}
            >
              <Typography variant="h2" mb={2}>
                NFT Turret Boxes & Rarity
              </Typography>

              <Typography variant="subtitle1" mb={2} textAlign="left">
                Each NFT Box is tied to a specific Turret type and contains one
                random NFT Turret of that type with a randomly assigned rarity
                and set of stats.
              </Typography>

              <Typography variant="subtitle1" mb={2} textAlign="left">
                Rarity drop rates are fixed and transparently displayed in the
                table below.
                <br />
                Higher-rarity NFT Turrets have a lower drop chance but have
                increased combat power, stronger bonuses, enhanced staking
                rewards, and higher marketplace value.
              </Typography>
            </Box>

            <Box maxWidth={820} sx={{ margin: "auto" }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Rarity</StyledTableCell>
                      <StyledTableCell>Distribution (%)</StyledTableCell>
                      <StyledTableCell>Pieces per 1,000</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <RarityItem
                      level={"Common"}
                      probability={"60%"}
                      amount={"600"}
                    />
                    <RarityItem
                      level={"Uncommon"}
                      probability={"30%"}
                      amount={"300"}
                    />
                    <RarityItem
                      level={"Rare"}
                      probability={"7%"}
                      amount={"70"}
                    />
                    <RarityItem
                      level={"Epic"}
                      probability={"2.5%"}
                      amount={"25"}
                    />
                    <RarityItem
                      level={"Legendary"}
                      probability={"0.5%"}
                      amount={"5"}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <ReferralProgram view="turrets" />
          </Container>
        </Box>
      </Box>
    </Box>
  )
}
export default NftBoxesTurrets2
